import React, { useState } from 'react';

import { CarMakeLogoProps } from './CarMakeLogo.interface';
import { useStyles } from './CarMakeLogo.styles';
import { useVehicleType } from 'app/shared/hooks/useVehicleType';
import { Image } from 'app/components/Image';

export default function CarMakeLogo({
  carMakeDictionaryEntryValue,
}: CarMakeLogoProps) {
  const classes = useStyles();
  const [fetchError, setFetchError] = useState<boolean>(false);
  const { isMotor } = useVehicleType();

  const carLogoFileName = carMakeDictionaryEntryValue
    .replace(' (USA)', '')
    .replace(' / ', '-')
    .replace(' [', '-')
    .replace(']', '')
    .replace(' (', '-')
    .replace(')', '')
    .replace(' ', '-')
    .replace(' ', '-')
    .replace(/\./g, '-')
    .replace(/\//g, '-')
    .toLowerCase();

  const defaultLogoFileName = isMotor ? 'default-motorbike' : 'default';
  const logoFileName = fetchError ? defaultLogoFileName : carLogoFileName;

  return (
    <div className={classes.root}>
      <Image
        onError={() => setFetchError(true)}
        src={`./images/logos/car-makes/${logoFileName}.png`}
        srcSetWebp={`./images/logos/car-makes/${logoFileName}.webp`}
        alt="car make logo"
        className={classes.logo}
      />
    </div>
  );
}
